<template>
  <div class="field">
    <span
      class="is-block p-b-sm"
      v-html="$wording.certify.text_13"
    />
    <div class="field has-addons">
      <div class="control">
        <button class="button is-static is-borderless">
          {{ streetAddress }}&nbsp;&nbsp;<strong>UNIT</strong>:
        </button>
      </div>
      <div class="control input-wrap required">
        <dropdown
          v-model="designator"
          name="selectDesignator"
          :options="designators"
          :default-option="`- Select unit type - `"
          @blur="blurEvent"
        />
      </div>
      <div class="control is-expanded">
        <textbox
          :value="unit"
          name="enterUnitName"
          placeholder="Unit name, e.g., A101"
          @input="setUnit"
          @blur="blurEvent"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/plugins/bus';
import { throttle } from 'lodash';

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      designators: {
        'UNIT': 'UNIT',
        'DEPT': 'DEPT',
        'APT': 'APT',
        'BLDG': 'BLDG',
        'FL': 'FL',
        'STE': 'STE',
        'RM': 'RM',
      },
    };
  },
  computed: {
    designator: {
      get() {
        let localDesc = this.value.split(" ");
        localDesc = String(localDesc ? localDesc[0] : this.value).toUpperCase().trim();
        return this.designators[localDesc] ?
          localDesc : '';
      },
      set(value) {
        this.emitUpdate(value, this.unit);
      },
    },
    unit: {
      get() {
        let localDesc = this.value.split(" ");
        localDesc = localDesc ? String(localDesc[0]) : false;
        if (!localDesc) {
          return this.value;
        }
        if (this.designators[localDesc.toUpperCase().trim()]
          && !!this.designator
        ) {
          return String(this.value).replace(localDesc, '').replace(/^\s+/g, '');
        }
        return String(this.value);
      },
      set(value) {
        this.emitUpdate(this.designator, value);
      },
    },
    streetAddress() {
      return this.$helpers.findDeepProp('selectedProperty.street_address', this.$store.state.properties)  || '';
    },
  },
  methods: {
    emitUpdate(designator, unit) {
      if (designator) {
        this.$emit('input', String(`${designator} ${unit}`));
      } else {
        this.$emit('input', String(unit));
      }
    },

    setUnit: throttle(function (unitValue) {
      this.unit = unitValue;
    }, 80),

    blurEvent() {
      EventBus.$emit('check-unit-names');
    },
  },
};
</script>
<style lang="scss" scoped>
  label.label {
    small {
      font-weight: 300 !important;
    }
  }
  .button.is-static {
    background-color: $ghost-gray;
    border-radius: 0;
    color: $dark-gray;
    font-weight: normal;
  }
</style>